import { render } from "./SocialShareButtons.vue?vue&type=template&id=55615ffc"
import script from "./SocialShareButtons.vue?vue&type=script&lang=js"
export * from "./SocialShareButtons.vue?vue&type=script&lang=js"

import "./SocialShareButtons.vue?vue&type=style&index=0&id=55615ffc&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__